import type { Adv } from "@/types/adv"
import { HttpClient, STATIC_ROOT } from "@/api/httpClient"

export default {
	list() {
		return HttpClient.get<Adv[]>(`${STATIC_ROOT}/adv`)
	}
}
